import { createContext, useContext, useEffect, useState } from "react";

export const PHONE_DISPLAY = "+90 533 856 7070";
export const PHONE_TEL = "tel:+905338567070";
export const waLink = (msg) =>
    `https://wa.me/905338567070?text=${encodeURIComponent(msg)}`;

export const LOCATIONS = [
    "Ercan Havalimanı",
    "Girne Merkez",
    "Girne Limanı",
    "Lefkoşa",
    "Gazimağusa",
    "İskele",
    "Lapta",
    "Alsancak",
    "Karaoğlanoğlu",
    "Bafra",
    "Güzelyurt",
];

const tr = {
    nav: {
        home: "Ana Sayfa",
        ercan: "Ercan Transfer",
        girne: "Girne Taksi",
        fleet: "Filomuz",
        pricing: "Fiyatlar",
        contact: "İletişim",
        call: "Hemen Ara",
    },
    hero: {
        eyebrow: "GİRNE • KKTC • 7/24 HİZMET",
        line1: "Kuzey Kıbrıs'ın",
        line2: "VIP Taksi &",
        line3: "Transfer Adresi",
        sub: "Tamamı Mercedes E-Class filomuz ve profesyonel şoförlerimizle Ercan Havalimanı VIP transferi, Girne içi lüks taksi ve özel şoförlü araç hizmeti.",
        ctaCall: "Hemen Ara",
        ctaWa: "WhatsApp Rezervasyon",
        waMsg: "Merhaba, Girne 1 Taksi VIP transfer / taksi hizmeti için rezervasyon yaptırmak istiyorum.",
        scroll: "Keşfet",
    },
    marquee:
        "ERCAN HAVALİMANI VIP TRANSFER ✦ GİRNE TAKSİ ✦ 7/24 ŞOFÖRLÜ ARAÇ ✦ MERCEDES E-CLASS FİLO ✦ SABİT FİYAT GARANTİSİ ✦ EKTIREN PROJECT ✦ ",
    booking: {
        title: "Hızlı Rezervasyon",
        sub: "Detayları seçin, rezervasyonunuz tek dokunuşla WhatsApp üzerinden bize ulaşsın.",
        from: "Nereden",
        to: "Nereye",
        date: "Tarih",
        time: "Saat",
        pax: "Kişi Sayısı",
        send: "WhatsApp ile Gönder",
        or: "veya",
        callNow: "Hemen Ara",
    },
    stats: [
        { value: "7/24", label: "Kesintisiz Hizmet" },
        { value: "%100", label: "Mercedes E-Class Filo" },
        { value: "45 dk", label: "Ercan — Girne" },
        { value: "Sabit", label: "Fiyat Garantisi" },
    ],
    statement: {
        label: "GİRNE 1 TAKSİ",
        title: "Bir yolculuktan fazlası; Girne'de ayrıcalıklı bir gelenek.",
        text: "Girne Limanı'nın ışıklarından Ercan Havalimanı'nın çıkış kapısına kadar, her yolculuğu birinci sınıf bir deneyime dönüştürüyoruz. Dakiklik, gizlilik ve lüks — her seferinde.",
    },
    services: {
        label: "HİZMETLERİMİZ",
        title: "Size Özel VIP Çözümler",
        sub: "İster havalimanı transferi, ister şehir içi ulaşım, ister gün boyu şoförlü araç — her ihtiyacınız için tek adres.",
        items: [
            {
                title: "Ercan VIP Transfer",
                desc: "Ercan Havalimanı'nda isim tabelası ile karşılama, uçuş takibi ve ücretsiz bekleme. Girne, Lefkoşa, Mağusa ve tüm KKTC'ye kapıdan kapıya transfer.",
                link: "Detaylı Bilgi",
            },
            {
                title: "Girne İçi Taksi",
                desc: "Girne merkez, liman, oteller, casinolar ve restoranlar arası hızlı ve lüks ulaşım. Tek dokunuşla arayın, dakikalar içinde kapınızda olalım.",
                link: "Detaylı Bilgi",
            },
            {
                title: "Özel Şoförlü Araç",
                desc: "İş toplantıları, özel günler, ada turları ve düğünler için saatlik veya günlük şoförlü Mercedes E-Class tahsisi.",
                link: "WhatsApp'tan Sor",
            },
        ],
    },
    fleet: {
        label: "FİLOMUZ",
        title: "Mercedes-Benz E-Class",
        sub: "Filomuzun tamamı, konfor ve prestijin simgesi son model Mercedes E-Class araçlardan oluşur.",
        specs: [
            "Ücretsiz Wi-Fi",
            "Deri İç Mekân",
            "İkram Su & Ferahlatıcılar",
            "Klima Kontrolü",
            "İngilizce Bilen Şoför",
            "Bebek Koltuğu (Ücretsiz)",
        ],
    },
    routes: {
        label: "POPÜLER GÜZERGAHLAR",
        title: "Bilinen Rotalar, Sabit Fiyatlar",
        sub: "Sürpriz yok, taksimetre stresi yok. Fiyatı yola çıkmadan öğrenin.",
        duration: "yaklaşık",
        cta: "Fiyat Al",
        fixed: "Sabit fiyat • Gizli ücret yok",
        waMsg: (r) => `Merhaba, ${r} güzergahı için fiyat ve rezervasyon bilgisi almak istiyorum.`,
        items: [
            { from: "Ercan Havalimanı", to: "Girne", time: "45 dk" },
            { from: "Ercan Havalimanı", to: "Lefkoşa", time: "25 dk" },
            { from: "Ercan Havalimanı", to: "Gazimağusa", time: "50 dk" },
            { from: "Ercan Havalimanı", to: "İskele", time: "55 dk" },
            { from: "Girne", to: "Lefkoşa", time: "30 dk" },
            { from: "Girne", to: "Lapta", time: "15 dk" },
            { from: "Girne", to: "Alsancak", time: "20 dk" },
            { from: "Girne", to: "Bafra", time: "70 dk" },
        ],
    },
    why: {
        label: "NEDEN GİRNE 1 TAKSİ",
        title: "VIP Standartların Tamamı, Tek Numarada",
        items: [
            { title: "7/24 Ulaşılabilirlik", desc: "Gece 03.00 uçuşu da, sabah 06.00 transferi de. Her zaman açık bir hat." },
            { title: "Uçuş Takibi", desc: "Uçağınız rötar yapsa bile şoförünüz sizi doğru anda karşılar, bekleme ücretsizdir." },
            { title: "Sabit Fiyat Garantisi", desc: "Anlaştığınız fiyat, ödediğiniz fiyattır. Trafik ve rota değişikliği fiyatı etkilemez." },
            { title: "Profesyonel Şoförler", desc: "Deneyimli, güler yüzlü ve adayı avucunun içi gibi bilen şoför kadrosu." },
            { title: "VIP Konfor", desc: "Ücretsiz su ikramı, Wi-Fi ve tertemiz deri koltuklarda klimalı yolculuk." },
            { title: "Gizlilik & Güven", desc: "İş dünyası ve özel misafirlerimiz için tam gizlilik esasıyla hizmet." },
        ],
    },
    testimonials: {
        label: "MİSAFİRLERİMİZ",
        title: "Yolcularımız Ne Diyor?",
        items: [
            { name: "Ahmet K.", tag: "İş Seyahati", text: "Ercan'dan Girne'ye gece yarısı transferimde şoför uçuş rötarına rağmen beni bekliyordu. Araç tertemiz, yolculuk kusursuzdu." },
            { name: "Sarah M.", tag: "Tatil", text: "The most professional taxi service in North Cyprus. On time, spotless Mercedes and a very kind driver. Highly recommended." },
            { name: "Mehmet & Elif", tag: "Balayı", text: "Otelimizden havalimanına VIP transfer aldık. İkramlar, konfor ve nezaket harikaydı. Girne'de tek tercihimiz." },
        ],
    },
    ektiren: {
        label: "BU PROJE BİR",
        name: "Ektiren Project",
        suffix: "ÜRÜNÜDÜR",
        text: "Tasarım ve mühendislik, dijitalde fark yaratan projelerin mimarı Ektiren Project imzası taşır.",
        footer: "Design & Engineering by Ektiren Project",
    },
    faq: {
        label: "MERAK EDİLENLER",
        title: "Sık Sorulan Sorular",
        items: [
            { q: "Ercan Havalimanı'nda beni nasıl bulacaksınız?", a: "Şoförümüz, yolcu çıkış kapısında üzerinde isminiz yazılı bir karşılama tabelası ile sizi bekler. Uçuş numaranızı paylaşmanız yeterlidir." },
            { q: "Uçağım rötar yaparsa ne olur?", a: "Uçuşunuzu canlı olarak takip ediyoruz. Rötar durumunda şoförünüz yeni iniş saatine göre sizi karşılar ve bekleme için ek ücret alınmaz." },
            { q: "Fiyatlar sabit mi?", a: "Evet. Rezervasyon sırasında anlaştığımız fiyat sabittir; trafik, rota veya gece tarifesi gibi nedenlerle değişmez. Gizli ücret yoktur." },
            { q: "Ödemeyi nasıl yapabilirim?", a: "Ödemenizi yolculuk sonunda nakit olarak yapabilirsiniz. Kurumsal ve düzenli müşterilerimiz için aylık cari çalışma imkânı da sunuyoruz." },
            { q: "Bebek koltuğu ve ek bagaj imkânı var mı?", a: "Bebek ve çocuk koltuğu talebiniz doğrultusunda ücretsiz temin edilir. E-Class bagaj hacmi 4 büyük valize rahatça yeter." },
            { q: "Gece geç saatte hizmet veriyor musunuz?", a: "Evet, 7 gün 24 saat hizmetinizdeyiz. Gece uçuşları ve gece hayatı dönüşleri için tek telefon yeterli." },
        ],
    },
    contact: {
        label: "İLETİŞİM",
        title: "Tek Numara, Sınırsız Konfor",
        sub: "Günün her saati bize ulaşın; aracınız dakikalar içinde kapınızda olsun.",
        callTitle: "Telefonla Ara",
        callDesc: "Tek dokunuşla doğrudan bize ulaşın",
        waTitle: "WhatsApp Rezervasyon",
        waDesc: "Mesajınız hazır, göndermeniz yeterli",
        area: "Hizmet Bölgesi",
        areaText: "Girne • Lefkoşa • Gazimağusa • İskele • Güzelyurt • Ercan Havalimanı ve tüm KKTC",
        hours: "7/24 Kesintisiz Hizmet",
    },
    footer: {
        desc: "KKTC'nin VIP taksi ve transfer markası. Mercedes E-Class filosu ile Ercan Havalimanı transferi, Girne içi taksi ve özel şoförlü araç hizmeti.",
        quickTitle: "Hızlı Erişim",
        routesTitle: "Popüler Rotalar",
        contactTitle: "İletişim",
        routes: ["Girne Taksi", "Ercan Transfer", "Lefkoşa VIP Taksi", "Gazimağusa Transfer", "Otel VIP Transfer", "Bafra Transfer"],
        rights: "Tüm hakları saklıdır.",
        madeBy: "Bu proje bir Ektiren Project ürünüdür",
    },
    floating: { call: "Hemen Ara", wa: "WhatsApp" },
    seo: {
        home: {
            title: "Girne 1 Taksi | Ercan Havalimanı VIP Transfer & Girne Taksi",
            desc: "KKTC'nin VIP taksi hizmeti: Ercan Havalimanı transferi, Girne içi lüks taksi, Mercedes E-Class filo. 7/24 — +90 533 856 7070",
        },
        ercan: {
            title: "Ercan Havalimanı VIP Transfer | Girne 1 Taksi",
            desc: "Ercan Havalimanı'ndan Girne, Lefkoşa ve tüm KKTC'ye VIP Mercedes E-Class transfer. Uçuş takibi, isimle karşılama, sabit fiyat. +90 533 856 7070",
        },
        girne: {
            title: "Girne Taksi | 7/24 VIP Şehir İçi Taksi — Girne 1 Taksi",
            desc: "Girne içi 7/24 VIP taksi: oteller, casinolar, restoranlar ve liman bölgesine Mercedes E-Class konforunda ulaşım. +90 533 856 7070",
        },
    },
};

const en = {
    nav: {
        home: "Home",
        ercan: "Ercan Transfer",
        girne: "Kyrenia Taxi",
        fleet: "Our Fleet",
        pricing: "Prices",
        contact: "Contact",
        call: "Call Now",
    },
    hero: {
        eyebrow: "KYRENIA • NORTH CYPRUS • 24/7 SERVICE",
        line1: "Northern Cyprus'",
        line2: "VIP Taxi &",
        line3: "Transfer Address",
        sub: "Ercan Airport VIP transfers, inner-Kyrenia luxury taxi and private chauffeured car service with our all-Mercedes E-Class fleet and professional drivers.",
        ctaCall: "Call Now",
        ctaWa: "WhatsApp Booking",
        waMsg: "Hello, I would like to book a Girne 1 Taksi VIP transfer / taxi service.",
        scroll: "Explore",
    },
    marquee:
        "ERCAN AIRPORT VIP TRANSFER ✦ KYRENIA TAXI ✦ 24/7 CHAUFFEURED CAR ✦ MERCEDES E-CLASS FLEET ✦ FIXED PRICE GUARANTEE ✦ EKTIREN PROJECT ✦ ",
    booking: {
        title: "Quick Booking",
        sub: "Pick your details — your request reaches us instantly via WhatsApp.",
        from: "Pickup",
        to: "Drop-off",
        date: "Date",
        time: "Time",
        pax: "Passengers",
        send: "Send via WhatsApp",
        or: "or",
        callNow: "Call Now",
    },
    stats: [
        { value: "24/7", label: "Non-stop Service" },
        { value: "100%", label: "Mercedes E-Class Fleet" },
        { value: "45 min", label: "Ercan — Kyrenia" },
        { value: "Fixed", label: "Price Guarantee" },
    ],
    statement: {
        label: "GIRNE 1 TAKSI",
        title: "More than a ride; a privileged tradition in Kyrenia.",
        text: "From the lights of Kyrenia Harbour to the arrivals gate of Ercan Airport, we turn every journey into a first-class experience. Punctuality, discretion and luxury — every single time.",
    },
    services: {
        label: "OUR SERVICES",
        title: "VIP Solutions Tailored For You",
        sub: "Airport transfer, city ride or a full-day chauffeured car — one address for every need.",
        items: [
            {
                title: "Ercan VIP Transfer",
                desc: "Name-board welcome at Ercan Airport, live flight tracking and free waiting. Door-to-door transfers to Kyrenia, Nicosia, Famagusta and all of North Cyprus.",
                link: "Learn More",
            },
            {
                title: "Kyrenia City Taxi",
                desc: "Fast and luxurious rides between Kyrenia centre, the harbour, hotels, casinos and restaurants. One tap and we are at your door in minutes.",
                link: "Learn More",
            },
            {
                title: "Private Chauffeur",
                desc: "Hourly or daily chauffeured Mercedes E-Class for business meetings, special occasions, island tours and weddings.",
                link: "Ask on WhatsApp",
            },
        ],
    },
    fleet: {
        label: "OUR FLEET",
        title: "Mercedes-Benz E-Class",
        sub: "Our entire fleet consists of latest-model Mercedes E-Class vehicles — the icon of comfort and prestige.",
        specs: [
            "Free Wi-Fi",
            "Leather Interior",
            "Complimentary Water",
            "Climate Control",
            "English-speaking Driver",
            "Baby Seat (Free)",
        ],
    },
    routes: {
        label: "POPULAR ROUTES",
        title: "Known Routes, Fixed Prices",
        sub: "No surprises, no meter stress. Know your price before you depart.",
        duration: "approx.",
        cta: "Get Price",
        fixed: "Fixed price • No hidden fees",
        waMsg: (r) => `Hello, I would like a price and booking for the ${r} route.`,
        items: [
            { from: "Ercan Airport", to: "Kyrenia", time: "45 min" },
            { from: "Ercan Airport", to: "Nicosia", time: "25 min" },
            { from: "Ercan Airport", to: "Famagusta", time: "50 min" },
            { from: "Ercan Airport", to: "Iskele", time: "55 min" },
            { from: "Kyrenia", to: "Nicosia", time: "30 min" },
            { from: "Kyrenia", to: "Lapta", time: "15 min" },
            { from: "Kyrenia", to: "Alsancak", time: "20 min" },
            { from: "Kyrenia", to: "Bafra", time: "70 min" },
        ],
    },
    why: {
        label: "WHY GIRNE 1 TAKSI",
        title: "Every VIP Standard, One Number",
        items: [
            { title: "24/7 Availability", desc: "A 3 AM flight or a 6 AM departure — one line that is always open." },
            { title: "Flight Tracking", desc: "Even if your flight is delayed, your driver meets you at the right moment. Waiting is free." },
            { title: "Fixed Price Guarantee", desc: "The price you agree is the price you pay. Traffic or route changes never affect it." },
            { title: "Professional Drivers", desc: "Experienced, friendly chauffeurs who know the island inside out." },
            { title: "VIP Comfort", desc: "Complimentary water, Wi-Fi and an air-conditioned ride on spotless leather seats." },
            { title: "Privacy & Trust", desc: "Complete discretion for our business and private guests." },
        ],
    },
    testimonials: {
        label: "OUR GUESTS",
        title: "What Our Passengers Say",
        items: [
            { name: "Ahmet K.", tag: "Business Trip", text: "On my midnight transfer from Ercan to Kyrenia, the driver was waiting despite the flight delay. Spotless car, flawless ride." },
            { name: "Sarah M.", tag: "Holiday", text: "The most professional taxi service in North Cyprus. On time, spotless Mercedes and a very kind driver. Highly recommended." },
            { name: "Mehmet & Elif", tag: "Honeymoon", text: "We took a VIP transfer from our hotel to the airport. The treats, comfort and courtesy were wonderful. Our only choice in Kyrenia." },
        ],
    },
    ektiren: {
        label: "THIS PROJECT IS A PRODUCT OF",
        name: "Ektiren Project",
        suffix: "",
        text: "Design and engineering carry the signature of Ektiren Project — the architect of digital experiences that stand out.",
        footer: "Design & Engineering by Ektiren Project",
    },
    faq: {
        label: "GOOD TO KNOW",
        title: "Frequently Asked Questions",
        items: [
            { q: "How will you find me at Ercan Airport?", a: "Our driver waits at the arrivals exit holding a board with your name on it. Simply share your flight number when booking." },
            { q: "What if my flight is delayed?", a: "We track your flight live. In case of a delay your driver greets you at the new arrival time — waiting is free of charge." },
            { q: "Are the prices fixed?", a: "Yes. The price agreed at booking is final; traffic, route or night hours never change it. No hidden fees." },
            { q: "How can I pay?", a: "You can pay in cash at the end of your ride. Monthly account arrangements are also available for corporate and regular clients." },
            { q: "Do you provide baby seats and extra luggage space?", a: "Baby and child seats are provided free upon request. The E-Class boot comfortably fits 4 large suitcases." },
            { q: "Do you operate late at night?", a: "Yes, we serve 24 hours a day, 7 days a week. One call is enough for night flights and late-night returns." },
        ],
    },
    contact: {
        label: "CONTACT",
        title: "One Number, Limitless Comfort",
        sub: "Reach us at any hour — your car will be at your door within minutes.",
        callTitle: "Call Directly",
        callDesc: "One tap connects you to us",
        waTitle: "WhatsApp Booking",
        waDesc: "Your message is ready — just hit send",
        area: "Service Area",
        areaText: "Kyrenia • Nicosia • Famagusta • Iskele • Güzelyurt • Ercan Airport and all of North Cyprus",
        hours: "24/7 Non-stop Service",
    },
    footer: {
        desc: "The VIP taxi and transfer brand of North Cyprus. Ercan Airport transfers, Kyrenia city taxi and private chauffeur service with a Mercedes E-Class fleet.",
        quickTitle: "Quick Links",
        routesTitle: "Popular Routes",
        contactTitle: "Contact",
        routes: ["Kyrenia Taxi", "Ercan Transfer", "Nicosia VIP Taxi", "Famagusta Transfer", "Hotel VIP Transfer", "Bafra Transfer"],
        rights: "All rights reserved.",
        madeBy: "This project is a product of Ektiren Project",
    },
    floating: { call: "Call Now", wa: "WhatsApp" },
    seo: {
        home: {
            title: "Girne 1 Taksi | Ercan Airport VIP Transfer & Kyrenia Taxi",
            desc: "North Cyprus VIP taxi service: Ercan Airport transfers, luxury Kyrenia taxi, Mercedes E-Class fleet. 24/7 — +90 533 856 7070",
        },
        ercan: {
            title: "Ercan Airport VIP Transfer | Girne 1 Taksi",
            desc: "VIP Mercedes E-Class transfers from Ercan Airport to Kyrenia, Nicosia and all of North Cyprus. Flight tracking, meet & greet, fixed prices. +90 533 856 7070",
        },
        girne: {
            title: "Kyrenia Taxi | 24/7 VIP City Taxi — Girne 1 Taksi",
            desc: "24/7 VIP taxi in Kyrenia: hotels, casinos, restaurants and the harbour in Mercedes E-Class comfort. +90 533 856 7070",
        },
    },
};

const dict = { tr, en };
const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState("tr");
    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);
    const t = (path) => {
        const val = path.split(".").reduce((o, k) => (o ? o[k] : undefined), dict[lang]);
        return val !== undefined ? val : path;
    };
    return (
        <LangCtx.Provider value={{ lang, setLang, t }}>
            {children}
        </LangCtx.Provider>
    );
};

export const useLang = () => useContext(LangCtx);
